import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const ordersApi = {
  create: (data) => api.post("/orders", data).then((r) => r.data),
  list: () => api.get("/orders").then((r) => r.data),
  get: (id) => api.get(`/orders/${id}`).then((r) => r.data),
  update: (id, data) => api.patch(`/orders/${id}`, data).then((r) => r.data),
  remove: (id) => api.delete(`/orders/${id}`).then((r) => r.data),
  saveAddress: (id, data) => api.post(`/orders/${id}/delivery-address`, data).then((r) => r.data),
};

export const customerApi = {
  login: (data) => api.post("/customer/login", data).then((r) => r.data),
  logActivity: (orderId, section) =>
    api.post("/customer/activity", { orderId, section }).then((r) => r.data),
  getActivity: (orderId) => api.get(`/customer/activity/${orderId}`).then((r) => r.data),
  suggestions: (orderId) => api.get(`/customer/suggestions/${orderId}`).then((r) => r.data),
  reports: (orderId) => api.get(`/customer/reports/${orderId}`).then((r) => r.data),
  reportDownloadUrl: (orderId, reportId) =>
    `${API}/customer/reports/${orderId}/${reportId}/download`,
};

export const vedicCalendarApi = {
  list: (params = {}) => api.get("/vedic-calendar", { params }).then((r) => r.data),
  create: (data) => api.post("/admin/vedic-calendar", data).then((r) => r.data),
  update: (id, data) => api.patch(`/admin/vedic-calendar/${id}`, data).then((r) => r.data),
  remove: (id) => api.delete(`/admin/vedic-calendar/${id}`).then((r) => r.data),
  generateReport: (data) => api.post("/admin/reports/generate-now", data).then((r) => r.data),
};

export const personalYearApi = {
  list: () => api.get("/personal-year-meanings").then((r) => r.data),
  update: (number, data) => api.patch(`/admin/personal-year-meanings/${number}`, data).then((r) => r.data),
};

export const inventoryApi = {
  list: () => api.get("/inventory").then((r) => r.data),
  seed: (items) => api.post("/inventory/seed", { items }).then((r) => r.data),
  update: (id, data) => api.patch(`/inventory/${id}`, data).then((r) => r.data),
};

export const quizApi = {
  step1: (data) => api.post("/quiz/step1", data).then((r) => r.data),
  step2: (id, data) => api.patch(`/quiz/${id}/step2`, data).then((r) => r.data),
  step3: (id, data) => api.patch(`/quiz/${id}/step3`, data).then((r) => r.data),
  reachedPayment: (id) => api.patch(`/quiz/${id}/reached-payment`).then((r) => r.data),
  paid: (id, data = {}) => api.patch(`/quiz/${id}/paid`, data).then((r) => r.data),
};

export const resumeApi = {
  lookup: (token, src) => api.get(`/resume/${token}`, { params: src ? { src } : {} }).then((r) => r.data),
};

export const abandonedApi = {
  list: (params = {}) => api.get("/admin/abandoned", { params }).then((r) => r.data),
  stats: () => api.get("/admin/abandoned/stats").then((r) => r.data),
  popupStats: () => api.get("/admin/popup-stats").then((r) => r.data),
  recoveryStats: () => api.get("/admin/recovery-stats").then((r) => r.data),
  sendEmail: (id, email_number) => api.post(`/admin/abandoned/${id}/send-email`, { email_number }).then((r) => r.data),
  markContacted: (id, contacted = true) => api.post(`/admin/abandoned/${id}/mark-contacted`, { contacted }).then((r) => r.data),
};

export const paymentsApi = {
  createOrder: (order_id) => api.post("/payments/razorpay/create-order", { order_id }).then((r) => r.data),
  verify: (data) => api.post("/payments/razorpay/verify", data).then((r) => r.data),
};
